<template>
	<button
		class="filter-tag"
		:disabled="disabled"
		type="button"
		:class="[color]"
		@click="$emit('click', this)"
	>
		<slot />
		<img src="../assets/close.svg" class="close-icon" />
	</button>
</template>

<script>
export default {
	name: 'filter-tag',
	props: ['color', 'disabled']
}
</script>

<style lang="scss">
.filter-tag {
	position: relative;
	display: flex;
	min-width: 60px;
	min-height: 32px;
	margin: 5px 10px;
	background: $purple;
	border: 0px;
	color: #fff;
	border-radius: 20px;
	padding: 8px 20px;
	padding-right: 50px;
	cursor: pointer;
	#text {
		font-weight: 400;
		font-size: 14px;
		line-height: 14px;
	}
	.close-icon {
		height: 0.75em;
		width: 0.75em;
		position: absolute;
		right: 10px;
		top: 0;
		bottom: 0;
		margin: auto;
	}
}
</style>
